import Svg, { Path, Rect } from 'react-native-svg';
import { type MinimalSvgProps, withDefaultIconProps } from './index';

export const AddressIcon6 = withDefaultIconProps(
  { height: 46, width: 47, color: '#1F2635' },
  ({ color, fillColor = '#F7E9AB', ...rest }: MinimalSvgProps & { fillColor?: string }) => (
    <Svg {...rest} viewBox="0 0 47 46">
      <Rect fill={fillColor} height="46" rx="8" width="46" transform={[{ translateX: 0.5 }]} />
      <Path
        d="M31.13 21.51C32.8 21.51 34.16 20.15 34.16 18.48C34.16 16.8 32.8 15.44 31.13 15.44C29.46 15.44 28.1 16.8 28.1 18.48C28.1 20.15 29.46 21.51 31.13 21.51ZM31.13 16.97C31.96 16.97 32.64 17.65 32.64 18.48C32.64 19.31 31.96 19.98 31.13 19.98C30.3 19.98 29.63 19.31 29.63 18.48C29.63 17.65 30.3 16.97 31.13 16.97Z"
        fill={color}
      />
      <Path
        d="M15.88 21.51C17.55 21.51 18.91 20.15 18.91 18.48C18.91 16.8 17.55 15.44 15.88 15.44C14.21 15.44 12.85 16.8 12.85 18.48C12.85 20.15 14.21 21.51 15.88 21.51ZM15.88 16.97C16.71 16.97 17.38 17.65 17.38 18.48C17.38 19.31 16.71 19.98 15.88 19.98C15.05 19.98 14.38 19.31 14.38 18.48C14.38 17.65 15.05 16.97 15.88 16.97Z"
        fill={color}
      />
      <Path
        d="M23.38 20.45C25.24 20.45 26.76 18.93 26.76 17.06C26.76 15.19 25.24 13.67 23.38 13.67C21.51 13.67 19.99 15.19 19.99 17.06C19.99 18.93 21.51 20.45 23.38 20.45ZM23.38 15.2C24.4 15.2 25.24 16.03 25.24 17.06C25.24 18.09 24.4 18.92 23.38 18.92C22.35 18.92 21.51 18.09 21.51 17.06C21.51 16.03 22.35 15.2 23.38 15.2Z"
        fill={color}
      />
      <Path
        d="M31.13 21.84C29.94 21.84 28.8 22.21 27.85 22.89C26.65 21.71 25.06 21.07 23.38 21.07C21.74 21.07 20.2 21.68 19.01 22.78C18.09 22.17 17 21.84 15.88 21.84C12.77 21.84 10.24 24.37 10.24 27.48V31.56C10.24 31.99 10.58 32.33 11 32.33H36.01C36.43 32.33 36.78 31.99 36.78 31.56V27.48C36.78 24.37 34.24 21.84 31.13 21.84ZM23.38 22.6C26.07 22.6 28.26 24.79 28.26 27.48V30.8H18.49V27.48C18.49 24.79 20.68 22.6 23.38 22.6ZM11.76 27.48C11.76 25.21 13.61 23.36 15.88 23.36C16.64 23.36 17.37 23.57 18.01 23.96C17.33 25 16.96 26.21 16.96 27.48V30.8H11.76V27.48ZM35.25 30.8H29.79V27.48C29.79 26.26 29.45 25.09 28.81 24.08C29.49 23.61 30.3 23.36 31.13 23.36C33.4 23.36 35.25 25.21 35.25 27.48V30.8Z"
        fill={color}
      />
    </Svg>
  ),
);
